import React from 'react';

const CircledCheck = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35">
		<title>Circled Checkmark</title>
		<desc>Gray circle outline with white background containing gray checkmark in the center.</desc>
		<path fill="#7C7C7A" fillRule="evenodd" d="M15.66 22.582l9.542-9.542a.896.896 0 1 0-1.267-1.268l-8.91 8.908-3.96-3.96a.896.896 0 1 0-1.267 1.268l4.594 4.594a.893.893 0 0 0 1.268 0M17.5 1.793C8.84 1.793 1.793 8.839 1.793 17.5c0 8.66 7.046 15.707 15.707 15.707 8.66 0 15.707-7.046 15.707-15.707 0-8.66-7.046-15.707-15.707-15.707M17.5 35C7.85 35 0 27.15 0 17.5S7.85 0 17.5 0 35 7.85 35 17.5 27.15 35 17.5 35"/>
	</svg>
);

export default CircledCheck;
